import advancedFilters from './advancedFilters.json';
import richTextEditor from './richTextEditor.json';
import agentBots from './agentBots.json';
import agentMgmt from './agentMgmt.json';
import attributesMgmt from './attributesMgmt.json';
import auditLogs from './auditLogs.json';
import automationFlows from './automationFlows.json';
import bulkActions from './bulkActions.json';
import campaign from './campaign.json';
import cannedMgmt from './cannedMgmt.json';
import chatlist from './chatlist.json';
import company from './company.json';
import flipLeads from './flipLeads.json';
import franchise from './franchise.json';
import contact from './contact.json';
import contactFilters from './contactFilters.json';
import conversation from './conversation.json';
import csatMgmt from './csatMgmt.json';
import emoji from './emoji.json';
import generalSettings from './generalSettings.json';
import helpCenter from './helpCenter.json';
import inboxMgmt from './inboxMgmt.json';
import integrationApps from './integrationApps.json';
import integrations from './integrations.json';
import internalChat from './internalChat.json';
import kanban from './kanban.json';
import labelsMgmt from './labelsMgmt.json';
import login from './login.json';
import report from './report.json';
import resetPassword from './resetPassword.json';
import search from './search.json';
import setNewPassword from './setNewPassword.json';
import settings from './settings.json';
import signup from './signup.json';
import teamsSettings from './teamsSettings.json';
import whatsappTemplates from './whatsappTemplates.json';
import webphone from './webphone.json';
import sla from './sla.json';
import surveys from './surveys.json';
import inbox from './inbox.json';
import general from './general.json';
import datePicker from './datePicker.json';
import customRole from './customRole.json';
import customReports from './customReports.json';
import dataTransfers from './dataTransfers.json';
import goals from './goals.json';
import tasksMgmt from './tasksMgmt.json';
import scheduledMessages from './scheduled_messages.json';
import releaseNotes from './releaseNotes.json';
import uazapiImport from './uazapiImport.json';

export default {
  ...advancedFilters,
  ...agentBots,
  ...agentMgmt,
  ...attributesMgmt,
  ...auditLogs,
  ...automationFlows,
  ...bulkActions,
  ...campaign,
  ...cannedMgmt,
  ...chatlist,
  ...company,
  ...flipLeads,
  ...franchise,
  ...contact,
  ...contactFilters,
  ...conversation,
  ...csatMgmt,
  ...emoji,
  ...generalSettings,
  ...helpCenter,
  ...inboxMgmt,
  ...integrationApps,
  ...integrations,
  ...internalChat,
  ...kanban,
  ...labelsMgmt,
  ...login,
  ...report,
  ...resetPassword,
  ...search,
  ...setNewPassword,
  ...settings,
  ...signup,
  ...sla,
  ...surveys,
  ...teamsSettings,
  ...whatsappTemplates,
  ...inbox,
  ...general,
  ...datePicker,
  ...customRole,
  ...customReports,
  ...dataTransfers,
  ...goals,
  ...webphone,
  ...tasksMgmt,
  ...scheduledMessages,
  ...releaseNotes,
  ...uazapiImport,

  ...richTextEditor,
};
